<script>
import resources from './resources'
import {TheMask} from 'vue-the-mask'

export default {
  name: 'profile',
  mixins: [resources],
  data () {
    return {
      date: new Date(),
      config: {
        locale: 'pt-br',
        format: 'DD/MM/YYYY',
        useCurrent: false,
        widgetPositioning: {
          horizontal: 'left',
          vertical: 'bottom'
        }
      }
    }
  },
  components: {
    TheMask
  }
}
</script>


<template lang="pug">
  page(icon="", title="Meu Cadastro")
    medibook-alert-custom-slot(
        :show='showModalAccountDisabled',
        @close='show = false',
        title='Perfeito',
        type='sa-success',
        message='Sua conta foi desativada com sucesso.',
        v-if="isDisabled")
          button.btn.find-filled.btn-margin-alert(@click.prevent='doLogout()')
            span.icon 
            | OK

    medibook-alert-custom-slot(
        :show='showModalPassword',
        @close='showModalPassword = false',
        title='Atenção',
        type='sa-warning',
        message='Favor informar sua senha atual',
        v-if="isPassword")
          disabled-account
    .col-xs-12.content
      .container-fluid
        .row
          .col-xs-12.white-bg
            .row
              .col-xs-12
                .col-sm-3
                  div(data-target='.change-photo', :class="{'cadastro-photo': user.type === 'patient', 'cadastro-photo-professional': user.type !== 'patient'}")
                    img(:src="user.avatar")
                    .button#uploadAvatar
                      span.icon 
                      .txt Alterar Foto de Perfil
                  .row
                    f-avatar

                div.col-sm-8
                  .accordion.cadastro
                    .panel
                      h4.panel-title(data-toggle='collapse', data-target='.collapsible-1', data-parent='.cadastro')
                        | DADOS PESSOAIS
                      .collapsible-1.collapse.in
                        .panel-body
                          .form-group(:class="{'has-error is-empty': $v.profile.name.$error}")
                            v-text(
                              label="Nome Completo",
                              id="name",
                              v-model="profile.name",
                              name="name",
                              autocomplete="off",
                              :status="$v.profile.name.$error ? 'error' : null",
                              @blur="$v.email.$touch()")

                            p.help-block(v-if='$v.profile.name.$error')
                              strong(v-if='!$v.profile.name.required')
                                | Campo obrigatório

                          .form-group
                            .row
                              .col-xs-12.col-md-4.margin-bottom(v-if="!userIsCompany")
                                .form-group(:class="{'has-error is-empty': $v.profile.birthdate.$error}")
                                  label Data de Nascimento
                                  v-datepicker(
                                    v-model="profile.birthdate",
                                    name="birthdate",
                                    :config='config')

                                  p.help-block(v-if='$v.profile.birthdate.$error')
                                    strong(v-if='!$v.profile.birthdate.required')
                                      | Campo obrigatório

                              .col-xs-12.col-md-4.margin-bottom(v-if="!userIsCompany")
                                f-select(
                                  label="Sexo",
                                  name="genre",
                                  v-model="profile.genre",
                                  :options="sexOptions",
                                  :searchable="true",
                                  :errors="errors['genre']")

                              .col-xs-12.col-md-4.margin-bottom
                                .form-group(:class="{'has-error is-empty': $v.profile.phones.mobile.$error}")
                                  label(style="margin-bottom: 5px; color: #a94442;", v-if="$v.profile.phones.mobile.$error") Celular
                                  label(style="margin-bottom: 5px;", v-if="!$v.profile.phones.mobile.$error") Celular
                                  the-mask.form-control(
                                    :mask="['## ####-####', '## # ####-####']",
                                    v-model="profile.phones.mobile",
                                    name="phone",
                                    placeholder="00 0000-0000")

                                  //-v-phone(
                                    id="phone",
                                    v-model="profile.phones.mobile",
                                    label="Telefone",
                                    name="phone",
                                    :status="$v.profile.phones.mobile.$error ? 'error' : null",
                                    @blur="$v.profile.phones.mobile.$touch()")

                                  //-p.help-block(v-if='$v.profile.phones.mobile.$error')
                                    strong(v-if='!$v.profile.phones.mobile.required')
                                      | Campo obrigatório

                                //- Removido pois já existe
                                //- label(style="margin-top:-0px;")
                                  input(type="checkbox", v-model="profile.sms")
                                  small Autorizo SMS
                                  a(href="#", data-toggle="tooltip", data-placement="top", title="Autorizar envio de SMS")
                                    span.icon 

                          .form-group(:class="{'has-error is-empty': $v.profile.email.$error}")
                            v-text(
                              label="Email"
                              id="email"
                              v-model="profile.email"
                              name="email",
                              autocomplete="off"
                              :status="$v.profile.email.$error ? 'error' : null"
                              @blur="$v.email.$touch()")

                            p.help-block(v-if='$v.profile.email.$error')
                              strong(v-if='!$v.profile.email.required')
                                | Campo obrigatório
                            p.help-block(v-if='$v.profile.email.$error && $v.profile.email.required')
                              strong(v-if='$v.profile.email.$invalid')
                                | Favor informar um email válido.

                            button.btn.exclude(@click.pevent="getPassword()")
                              span.icon 
                              |  Desativar Conta
                            button.btn.save.pull-right(@click.prevent="doSave()")
                              span.icon 
                              |  Salvar Alterações
                              .border-botton
                    .panel
                      h4.panel-title(data-toggle='collapse', data-target='.collapsible-2', data-parent='.cadastro')
                        | SEGURANÇA
                      change-password
</template>



// WEBPACK FOOTER //
// src/app/settings/profile/me.vue